import CartProductItemModel from './CartProductItemModel';
import VariantModel from 'coreClasses/product/VariantModel';

/**
 * Represents CartInfoModel
 */
export default class CartInfoModel {
	public cart_quantity: number;
	public cart_value: number;
	public cart_products: CartProductItemModel[];

	/**
	 * @constructor
	 * @param {object} basketInfo - basket
	 */
	constructor(basketInfo: any) {
		this.cart_quantity = basketInfo?.itemsCount;
		this.cart_value = basketInfo?.orderTotal || basketInfo?.productTotal;

		this.cart_products = basketInfo?.productItems?.map((productItem) => {
			const managerRepository = productItem.managerRepository;
			const product = managerRepository.getProductsMgr().getProduct(productItem.productId);

			return {...new CartProductItemModel(productItem, product as VariantModel)};
		});
	}
}
